import React, { useState, useEffect, useRef } from 'react';

const EVENT_ICONS = {
  settlement: '\u2B1B',
  burn: '\uD83D\uDD25',
  register: '\u2795',
  dispute: '\u26A0\uFE0F',
  claim: '\uD83D\uDCB0',
  reputation: '\u2B50',
  delist: '\u274C',
};

const EVENT_COLORS = {
  settlement: 'border-purple-500/30 bg-purple-500/5',
  burn: 'border-orange-500/30 bg-orange-500/5',
  register: 'border-emerald-500/30 bg-emerald-500/5',
  dispute: 'border-yellow-500/30 bg-yellow-500/5',
  claim: 'border-blue-500/30 bg-blue-500/5',
  reputation: 'border-cyan-500/30 bg-cyan-500/5',
  delist: 'border-red-500/30 bg-red-500/5',
};

function shortWallet(w) {
  if (!w || w.length < 12) return w || '???';
  return w.slice(0, 4) + '...' + w.slice(-4);
}

function timeAgo(ts) {
  const diff = (Date.now() - ts) / 1000;
  if (diff < 60) return `${Math.floor(diff)}s ago`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return `${Math.floor(diff / 86400)}d ago`;
}

export default function ActivityFeed({ activities }) {
  const feedRef = useRef(null);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 5000);
    return () => clearInterval(t);
  }, []);

  // Auto-scroll to top on new activity
  useEffect(() => {
    if (feedRef.current) feedRef.current.scrollTop = 0;
  }, [activities?.length]);

  if (!activities || activities.length === 0) {
    return (
      <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-3 sm:p-4 overflow-hidden">
        <h3 className="text-xs text-slate-500 uppercase tracking-wider mb-3">Activity Feed</h3>
        <div className="text-center py-8 text-slate-600 text-xs">
          <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse mx-auto mb-2"></div>
          Listening for on-chain events...
        </div>
      </div>
    );
  }

  return (
    <div className="bg-slate-900/60 border border-slate-800 rounded-xl p-3 sm:p-4 overflow-hidden">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-xs text-slate-500 uppercase tracking-wider">Activity Feed</h3>
        <span className="flex items-center gap-1.5 text-[10px] text-emerald-500">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
          Live
        </span>
      </div>
      <div ref={feedRef} className="space-y-2 max-h-80 overflow-y-auto pr-1 scrollbar-thin">
        {activities.map((a, i) => (
          <div
            key={i}
            className={`flex items-start gap-3 px-3 py-2.5 rounded-lg border transition-all ${
              EVENT_COLORS[a.type] || 'border-slate-800 bg-slate-800/30'
            } ${i === 0 ? 'animate-slideIn' : ''}`}
          >
            <span className="text-sm mt-0.5">{EVENT_ICONS[a.type] || '\u2022'}</span>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-slate-200 leading-relaxed">{a.message}</p>
              <p className="text-[10px] text-slate-500 mt-0.5">{timeAgo(a.timestamp)}</p>
            </div>
            {a.amount && (
              <span className="text-xs font-mono text-slate-400 whitespace-nowrap">{a.amount}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
